import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from './App2';
import App from "./App";
// import App from './App/App2.jsx';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
